import config from "../../../config/config";
import Axios from "axios";

const Township_Url = config.baseUrl + "township";
const Part_Url = config.baseUrl + "part";
const City_Url = config.baseUrl + "city";
const Village_Url = config.baseUrl + "village";
const RuralArea_Url = config.baseUrl + "ruralarea";

export const getAllRuralArea = (params) => {
  return Axios.get(RuralArea_Url, {
    params,
  });
};

export const getAllTownship = (params) => {
  return Axios.get(Township_Url, {
    params,
  });
};

export const getAllPart = (params) => {
  return Axios.get(Part_Url, {
    params,
  });
};

export const getAllCity = (params) => {
  return Axios.get(City_Url, {
    params,
  });
};

export const getAllVillage = (params) => {
  return Axios.get(Village_Url, {
    params,
  });
};
